import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './TokenExpirationModal.css';
import axiosInstance from '../../variables/api/axiosInstance';

const TokenExpirationModal = () => {
    const [showModal, setShowModal] = useState(false);
    const [timeLeft, setTimeLeft] = useState(900000);
    const navigate = useNavigate();

    // Fonction pour régénérer le token
    const regenerateToken = async () => {
        try {
            const response = await axiosInstance.post('/api/refresh-token', {});
            // console.log(response);
            if (response.status === 200) {
                const data = await response.data;

                // Stocker le nouveau token
                const tokenParts = data?.split('.');
                sessionStorage.setItem('n', tokenParts[0]);
                sessionStorage.setItem('t', tokenParts[1]);
                sessionStorage.setItem('k', tokenParts[2]);

                toast.success('Session prolongée avec succès');
                setShowModal(false);
                setTimeLeft(900000);
            } else {
                throw new Error('Échec de la régénération du token');
            }
        } catch (error) {
            console.error('Erreur lors de la régénération du token:', error);
            toast.error('Impossible de prolonger la session');
            handleLogout();
        }
    };

    // Fonction pour obtenir le token
    const getToken = () => {
        return sessionStorage.getItem('n') + '.' +
            sessionStorage.getItem('t') + '.' +
            sessionStorage.getItem('k');
    };

    // Fonction de déconnexion
    const handleLogout = () => {
        sessionStorage.clear();
        setShowModal(false);
        navigate('/connexion');
        toast.info('Votre session a expiré');
    };

    // Fonction pour vérifier l'expiration du token
    const checkTokenExpiration = () => {
        const token = getToken();

        if (token === 'null.null.null') {
            return;
        }

        try {
            const { exp } = jwtDecode(token);
            const currentTime = new Date().getTime();
            const expirationTime = exp * 1000;
            const timeUntilExpiration = expirationTime - currentTime;

            // 15 secondes avant l'expiration (15000 ms)
            if (timeUntilExpiration <= 900000 && timeUntilExpiration > 0) {
                if (!showModal) {
                    setShowModal(true);
                    setTimeLeft(Math.ceil(timeUntilExpiration / 1000));
                }
            } else if (timeUntilExpiration <= 0) {
                handleLogout();
            }
        } catch (error) {
            console.error('Erreur lors du décodage du token:', error);
        }
    };

    // Effet pour vérifier régulièrement l'expiration
    useEffect(() => {
        const interval = setInterval(() => {
            checkTokenExpiration();
        }, 1000); // Vérifier chaque seconde

        return () => clearInterval(interval);
    }, [showModal]);

    // Effet pour le compte à rebours dans le modal
    useEffect(() => {
        if (showModal && timeLeft > 0) {
            const countdown = setInterval(() => {
                setTimeLeft(prev => {
                    if (prev <= 1) {
                        handleLogout();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(countdown);
        }
    }, [showModal, timeLeft]);

    // Gérer la continuation de la session
    const handleContinue = () => {
        regenerateToken();
    };

    // Gérer la déconnexion volontaire
    const handleDisconnect = () => {
        handleLogout();
    };

    if (!showModal) return null;

    return (
        <div className="token-modal-overlay">
            <div className="token-modal">
                <div className="token-modal-header">
                    <h2>⚠️ Session sur le point d'expirer</h2>
                </div>

                <div className="token-modal-body">
                    <p>Votre session va expirer dans <strong>{timeLeft} seconde{timeLeft > 1 ? 's' : ''}</strong>.</p>
                    <p>Souhaitez-vous continuer votre session ?</p>
                </div>

                <div className="token-modal-footer">
                    <button
                        className="btn-disconnect"
                        onClick={handleDisconnect}
                    >
                        Se déconnecter
                    </button>
                    <button
                        className="btn-continue"
                        onClick={handleContinue}
                    >
                        Continuer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TokenExpirationModal;